import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const AuthLayout = () => (
    <AuthWrapper>
        <AuthContainer>
            <AuthContent>
                <Outlet /> {/* Renders the specific authentication page, e.g., LoginPage, RegisterPage */}
            </AuthContent>
        </AuthContainer>
    </AuthWrapper>
);

export default AuthLayout;

// Styled Components
const AuthWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: #ffffff;
    position: relative;
    /* Only the decorative background may be clipped. Clipping the y axis as
       well would swallow the submit button of a tall form on a short screen. */
    overflow-x: hidden;
`;

const AuthContainer = styled.div`
    position: relative;
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const AuthContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;
